import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';

import Switch from 'app/scripts/components/common/inputs/customs/switch';
import { getLazyLoadMargin, updateLazyLoadValue } from './actions';
import { parseNumber, isNumber } from './utils';

const defaultValue = 800;
import styled from 'styled-components';

const NumberInput = styled('input')`
  background-color: #fff;
  border-radius: 6px;
  border: 1px solid #d4d6d7;
  box-shadow: inset 0px 3px 2px 0px rgba(0, 0, 0, 0.05);
  color: #a8abae;
  font-family: 'Open Sans', Helvetica, Arial, sans-serif;
  font-size: 13px;
  line-height: 18px;
  outline: none;
  position: relative;
  transition: background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease,
    color 0.2s ease, opacity 0.2s ease;
  vertical-align: middle;
  width: 100%;
  z-index: 1;
  padding: 7px 10px;
`;

export class LazyLoadMargin extends Component {
  static displayName = 'LazyLoadMargin';

  static lastValue = defaultValue;

  static propTypes = {
    spotId: PropTypes.string.isRequired
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      lazyLoadMargin: false
    };
  }

  async componentDidMount() {
    const { spotId } = this.props;
    let lazyLoadMargin = await getLazyLoadMargin(spotId);
    lazyLoadMargin = parseNumber(lazyLoadMargin);
    this.setState({ lazyLoadMargin });
  }

  async toggleLazyLoad(lazyLoadMargin) {
    const { spotId } = this.props;
    this.setState({ lazyLoadMargin });
    if (lazyLoadMargin === true) {
      lazyLoadMargin = LazyLoadMargin.lastValue;
      this.setState({ lazyLoadMargin });
      await updateLazyLoadValue(lazyLoadMargin + 'px', spotId);
    } else {
      await updateLazyLoadValue('false', spotId);
    }
  }

  async updatePx(lazyLoadMargin) {
    const { spotId } = this.props;

    if (isNumber(lazyLoadMargin) === false) {
      return;
    }

    lazyLoadMargin = parseNumber(lazyLoadMargin);
    this.setState({ lazyLoadMargin });
    LazyLoadMargin.lastValue = lazyLoadMargin;

    await updateLazyLoadValue(lazyLoadMargin + 'px', spotId);
  }

  changePx(lazyLoadMargin) {
    if (lazyLoadMargin === '') {
      this.setState({ lazyLoadMargin: false });
      LazyLoadMargin.lastValue = lazyLoadMargin;
      return;
    }
    this.updatePx(lazyLoadMargin);
  }

  @autobind
  changeValue(number, toggle) {
    if (number === '' || number === null || toggle === true) {
      return this.toggleLazyLoad(toggle);
    }
    return this.changePx(number);
  }

  @autobind
  handleBlur(lazyLoadMargin) {
    if (lazyLoadMargin === '') {
      lazyLoadMargin = LazyLoadMargin.lastValue;
      if (isNumber(lazyLoadMargin) === false) {
        lazyLoadMargin = LazyLoadMargin.lastValue;
        lazyLoadMargin = defaultValue;
        LazyLoadMargin.lastValue = defaultValue;
      }
      this.setState({ lazyLoadMargin });
    }
  }

  render() {
    const { lazyLoadMargin } = this.state;

    const showNumberInput = isNumber(lazyLoadMargin);

    let numberInput = null;
    if (showNumberInput === true) {
      numberInput = (
        <div className="text-field-regular">
          <div className="field-description">
            Insert the amount of pixels for the lazy load margin
          </div>
          <NumberInput
            type="number"
            min="1"
            step={1}
            value={lazyLoadMargin}
            onChange={event => this.changeValue(event.target.value)}
            onBlur={event => this.handleBlur(event.target.value)}
          />
        </div>
      );
    }

    const toggleValue = showNumberInput;

    return (
      <div className="">
        <br />
        <h5 className="sso-title">Conversation Lazy Load</h5>
        <Switch
          title="Enable Lazy Load"
          description=""
          value={toggleValue}
          onChange={val => this.changeValue(null, val)}
        />
        {numberInput}
      </div>
    );
  }
}
